import "./services.css";
import { useLanguage } from "../../context/LanguageContext";
import { motion } from "framer-motion";
import React, { forwardRef } from "react";

const services = [
    {
        icon: "bx bx-layer",
        titleKey: "services.arch.title",
        descKey: "services.arch.desc",
        tags: ["Java", "Spring Boot", "MariaDB", "REST APIs", "Microservices"],
    },
    {
        icon: "bx bx-devices",
        titleKey: "services.mobile.title",
        descKey: "services.mobile.desc",
        tags: ["React", "React Native", "iOS", "Android"],
        featured: true,
    },
    {
        icon: "bx bx-transfer",
        titleKey: "services.fintech.title",
        descKey: "services.fintech.desc",
        tags: ["dLocal", "Belo", "TransFi", "n8n", "KYC/KYB"],
    },
];

const Services = forwardRef<HTMLElement>((props, ref) => {
    const { t } = useLanguage();

    return (
        <section className="services-section" id="Services" ref={ref}>
            <div className="services-container">
                <motion.div
                    className="services-header"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    <h2>{t("services.title")}</h2>
                    <p>{t("services.subtitle")}</p>
                </motion.div>

                <div className="services-grid">
                    {services.map((service, index) => (
                        <motion.div
                            key={service.titleKey}
                            className={`service-card${service.featured ? " service-card--featured" : ""}`}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.15 }}
                            viewport={{ once: true }}
                        >
                            {service.featured && (
                                <div className="service-featured-badge">★ Most Requested</div>
                            )}
                            <div className="service-icon">
                                <i className={service.icon}></i>
                            </div>
                            <h3>{t(service.titleKey)}</h3>
                            <p>{t(service.descKey)}</p>
                            <div className="service-tags">
                                {service.tags.map((tag) => (
                                    <span key={tag} className="service-tag">{tag}</span>
                                ))}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
});

export default Services;
